import { api } from "../../services/api";
import { ShowToast } from "../../services/toast";

/**
 * Backend sync when the user completes or skips onboarding: complete questionnaire
 * first, then refresh roadmap (fetchRoadMap must run only after completeQuestionnaire).
 * @returns true if both steps succeeded, false otherwise (caller can skip follow-up like onContinue).
 */
export async function completeOnboardingSync(
  fetchRoadMap: () => Promise<unknown>,
  options: { onError: "toast" | "ignore" }
): Promise<boolean> {
  try {
    await api.completeQuestionnaire();
    await fetchRoadMap();
    return true;
  } catch {
    if (options.onError === "toast") {
      ShowToast({
        message: "Error completing onboarding",
        type: "error",
      });
    }
    return false;
  }
}
